/*
  Fremont Fashion — wishlist store
  Theme: Refresh (Dawn-based)

  Loaded site-wide from layout/theme.liquid:
    <script src="{{ 'fremont-wishlist.js' | asset_url }}" defer="defer"></script>

  Owns three things:
    1. the saved list in localStorage
    2. the heart buttons on product cards
    3. the count bubble in the header

  Items are stored as product HANDLES, not IDs. The new-arrivals carousel
  already stored handles under the same key, so storing IDs here meant the two
  wrote incompatible values into one list — something saved on the homepage
  did not read as saved on the collection page, and vice versa.
*/
(function () {
  'use strict';

  var KEY = 'fremont:wishlist';

  function read() {
    try {
      var parsed = JSON.parse(window.localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(parsed)) return [];
      // Drop legacy numeric IDs left over from the earlier build — they can't
      // be resolved back to a product.
      return parsed.filter(function (item) {
        return typeof item === 'string' && !/^\d+$/.test(item);
      });
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {
      /* storage full or blocked — the UI still responds */
    }
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { items: list } }));
  }

  function paint(button, saved) {
    button.classList.toggle('ff-wish--active', saved);
    button.setAttribute('aria-pressed', saved ? 'true' : 'false');
    button.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Add to wishlist');
  }

  function sync(root) {
    var saved = read();
    (root || document).querySelectorAll('[data-ff-wish]').forEach(function (button) {
      paint(button, saved.indexOf(button.dataset.productHandle) !== -1);
    });
    broadcast(saved.length);
  }

  function broadcast(count) {
    document.querySelectorAll('[data-wishlist-count], [data-ff-wish-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  window.FremontWishlist = {
    read: read,
    has: function (handle) {
      return read().indexOf(handle) !== -1;
    },
    remove: function (handle) {
      var list = read();
      var index = list.indexOf(handle);
      if (index === -1) return;
      list.splice(index, 1);
      write(list);
    },
  };

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-ff-wish]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    var handle = button.dataset.productHandle;
    if (!handle) return;

    var list = read();
    var index = list.indexOf(handle);

    if (index === -1) {
      list.push(handle);
      button.classList.add('ff-wish--pop');
      setTimeout(function () {
        button.classList.remove('ff-wish--pop');
      }, 320);
    } else {
      list.splice(index, 1);
    }

    write(list);
  });

  // Keeps every heart and the header bubble in step, whichever script made the
  // change — the carousel section carries its own copy of this logic.
  document.addEventListener('wishlist:updated', function () {
    sync(document);
  });

  function boot() {
    sync(document);

    var grid = document.getElementById('ProductGridContainer');
    if (!grid || !window.MutationObserver) return;

    // facets.js rebuilds the grid on every filter change.
    new MutationObserver(function () {
      sync(grid);
    }).observe(grid, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();